import { useFetch } from 'vfetcher';
import { triggerSessionExpired } from "./error/sessionExpired";
// OLD: import store from '@/store';
// OLD: import router from "@/router";
// OLD: import { useErrorHandler, ErroneousResponseError } from "./error";

// OLD:
// const handleResponseError = (internal, friendly) => {
//   useErrorHandler(new ErroneousResponseError(internal, friendly), {
//     notify: true,
//     fallback: 'Sorry, access to this resource forbidden.',
//   });
// }

export function useAPI(url, options = {}) {
  const platformHeader = {
    "Dougjones": "web",
  };

  return useFetch(url, {
    ...options,
    baseURL: '/api',
    headers: {
      ...options.headers,
      ...platformHeader,
    },
    async onResponseError({ request, options, response }) {
      if (typeof response._data === 'object') {
        // OLD:
        // const internal = response._data.message;
        // if (response.status === 403) {
        //   const friendly = 'This account no longer exists. Contact support for help, or log out to return to the home screen.';
        //   handleResponseError(internal, friendly);
        // }
        // if (response.status === 401) {
        //   const friendly = 'Session expired. Please log in to continue.';
        //   store.dispatch('logOut');
        //   //router.go(); Test later which are better to use
        //   router.push('/');
        //   handleResponseError(internal, friendly);
        // }

        // NEW: account-deleted keeps its own message; any other 401/403 trips
        // the shared session-expired popup instead of logging out per request.
        if (response.status === 403 && response._data.code === 403021) {
          const friendly = 'This account no longer exists. Contact support for help, or log out to return to the home screen.';
          triggerSessionExpired(friendly);
          return;
        }
        if (response.status === 401 || response.status === 403) {
          triggerSessionExpired();
        }
      }
    }
  })
}
